import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { IObservation } from '../../../message-models/observation.interface';
import { IDateTimeWithZone } from '../../../common/date-time-with-zone.interface';
import { ObservationTypeString } from '../../../domain-model/observation.class';

@Component({
  selector: 'app-observation-form',
  templateUrl: './observation-form.component.html',
  styleUrls: ['./observation-form.component.scss']
})
export class ObservationFormComponent implements OnInit {
  @Input() observation: IObservation;
  @Input() isEditing: boolean;
  @Input() saveAttempted: boolean = true;
  observationType: typeof ObservationTypeString = ObservationTypeString;
  selectedObservationType: string;

  @Output() canSave: EventEmitter<boolean> = new EventEmitter<boolean>();

  editorOptions = {
    toolbar: [['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    ['blockquote', 'code-block'],
    [{ 'list': 'ordered' }, { 'list': 'bullet' }],]
  };

  observedOnMaxDate: Date = new Date(Date.now());
  followUpMinDate: Date;

  constructor() { }

  ngOnInit(): void {
    if (this.observation && this.observation?.observedOn?.dateTime) {
      this.disableDatesPriorSelected(this.observation?.observedOn)
      this.selectedObservationType = this.observationType[this.observation.observationType];
    }
  }

  disableDatesPriorSelected(date: IDateTimeWithZone) {
    if (date.dateTime) {
      let observedOn = new Date(date.dateTime);
      this.followUpMinDate = new Date(observedOn.setDate(observedOn.getDate() + 1));
    }
  }

  setDateLimits() {
    let followupOn = new Date(this.observation?.followUpOn?.dateTime);
    let currentDate = new Date(Date.now());
    let newMaxDate = new Date(followupOn.setDate(followupOn.getDate() - 1));
    this.observedOnMaxDate = currentDate < newMaxDate ? currentDate : newMaxDate;
  }
}
